<template>
  <div>
    <b-row no-gutters class="align-items-center">
      <div class="col-xl-3 col-lg-3 col-12 pt-4 pb-2 p-lg-0 order-lg-1 order-3">
        <div
          class="d-flex align-items-center justify-content-start justify-content-lg-end mt-lg-auto my-2 ml-3 mb-lg-0 pl-3 pl-md-5 pl-lg-4">
          <!-- circle choice -->
          <div class="ansIcon d-flex flex-column mx-1" v-for="(j, index2) in item.sel" :key="index2"
            :class="{ active:(conselectedAns[item.questionnumber - 1]==j.value),
                isFinish:finish2 && ShowCorrectAns(AllAns[item.questionnumber - 1].ans, j.value),
                ishoverSel:(ishover.index === item.questionnumber - 1)&&(ishover.index2 === index2) && (ishover.status === true)
                }">
            <template>
              <button :id="'btn_'+index2+'_off'"
                class="border-0 btn-ansertool btn p-0 shadow-sm rounded-circle d-flex flex-fill justify-content-center align-items-center"
                @mouseover="overEvent(item.questionnumber, index2, true)"
                @mouseleave="leaveEvent(item.questionnumber, index2, false)" @click="selectAns(item.questionnumber,
                          j.value, AllAns[item.questionnumber - 1].group),selectAns2(item.questionnumber,
                          j.value, AllAns[item.questionnumber - 1].group) "
                style="width:40px;height:40px;"
                :class="{
                  'text-white btn-success':finish2 && ShowCorrectAns(AllAns[item.questionnumber - 1].ans, j.value)&&(conselectedAns[item.questionnumber - 1]===j.value),
                  'btn-gold':(!allwaysAns && conselectedAns[item.questionnumber - 1]==j.value&&(!finish2||AllAns[item.questionnumber - 1].ans.indexOf(conselectedAns[item.questionnumber - 1]) === -1))||((allwaysAns&&conselectedAns[item.questionnumber - 1] === j.value))&&(AllAns[item.questionnumber - 1].ans.indexOf(conselectedAns[item.questionnumber - 1])=== -1),
                  'text-white btn-gold':finish2 && ShowCorrectAns(AllAns[item.questionnumber - 1].ans, j.value)&&(AllAns[item.questionnumber - 1].ans.indexOf(conselectedAns[item.questionnumber - 1]) === -1),
                  'btn-success text-white right':(selectedStatus[item.questionnumber - 1]&&(AllAns[item.questionnumber - 1].ans.indexOf(j.value)!== -1))&&(allwaysAns&&conselectedAns[item.questionnumber - 1] === j.value),
                  'btn-gold text-white right':allwaysAns &&((conselectedShowStatus[item.questionnumber - 1]&&(AllAns[item.questionnumber - 1].ans.indexOf(j.value)!== -1))||(selectedStatus[item.questionnumber - 1]&&(AllAns[item.questionnumber - 1].ans.indexOf(j.value)!== -1)&&(AllAns[item.questionnumber - 1].ans.indexOf(conselectedAns[item.questionnumber - 1])=== -1)))}">
                <span
                  v-if="((allwaysAns&&conselectedAns[item.questionnumber - 1] === j.value))&&(AllAns[item.questionnumber - 1].ans.indexOf(conselectedAns[item.questionnumber - 1])=== -1)"
                  class="position-absolute text-danger mt-n1">
                  <font-awesome-icon :icon="['fas', 'times']" style="font-size:3.5rem" />
                  -1
                </span>
                <span
                  v-if="(finish2&& !allwaysAns && conselectedAns[item.questionnumber - 1]==j.value&&(!finish2||AllAns[item.questionnumber - 1].ans.indexOf(conselectedAns[item.questionnumber - 1]) === -1))"
                  class="position-absolute text-danger mt-n1">
                  <font-awesome-icon :icon="['fas', 'times']" style="font-size:3.5rem" />
                </span>
              </button>

            </template>
          </div>
          <!-- circle mark -->
          <div class="ansIcon">
            <button :id="'tooltip-target-'+item.questionnumber"
              :class="{'btn-deepgold text-white':questionTag_clone[item.questionnumber - 1]}"
              class="btn-ansertool btn bg-white shadow-sm border-secondary rounded-circle mx-1 d-flex justify-content-center align-items-center"
              @click="tagQuestion(item.questionnumber)" style="width:40px;height:40px;">
              <font-awesome-icon :icon="['fas', 'star']" class="d-inline-block mt-n1"
                style="font-size:12px" />
            </button>
            <b-tooltip :target="'tooltip-target-'+item.questionnumber" triggers="hover"
              placement="bottom">
              標記此題
            </b-tooltip>
          </div>
        </div>
        <div class='col-12 pl-4 pt-3' v-if='finish2'>
          <button class='btn btn-outline-warning' @click='showquestion(item)'>
            {{getshowinfoquestion(item)?"關閉解析":"觀看解析"}}</button>
        </div>
      </div>
      <div class="col-xl-9 col-lg-9 col-12 order-lg-2 order-1">
        <div class="row no-gutters">
          <div class="col-12">
            <b-card-body>
              <b-card-text id="qTitle">
                <!-- {{ `${index + 1}.${item.title}` }} -->
                <div class="d-flex">
                  <div class="question_number text-right pr-lg-2 flex-shrink-0">
                    {{item.questionnumber}}.</div>
                  <div class="pr-lg-5">
                    <div class="text-justify" v-html="`${item.title}`"></div>
                    <small class="notes" v-if="getshowinfoquestion(item)"
                      v-html="item.notes_title"></small>
                  </div>
                </div>
              </b-card-text>
            </b-card-body>
          </div>
        </div>
      </div>
      <div class="col-xl-9 col-lg-9 offset-lg-3 col-12 order-lg-3 order-2">
        <div class="row no-gutters">
          <div class="col-12">
            <b-card-body class="pt-0 pb-0">
              <b-card-text class="qChoice pr-lg-5">
                <!-- {{ `${index + 1}.${item.title}` }} -->
                <div class="d-flex">
                  <div class="flex-fill" :class="{'bg-status':finish2||allwaysAns}">
                    <div class="questionAll" v-for="(i, index3) in item.sel" :key="index3"
                      :class="{active:conselectedAns[item.questionnumber - 1]===i.value,
                        isFinish:finish2 && ShowCorrectAns(AllAns[item.questionnumber - 1].ans,i.value),
                        ishoverSel:(ishover.index === item.questionnumber - 1)&&(ishover.index2 === index3) && (ishover.status === true)}"
                      @mouseover="overEvent(item.questionnumber, index3, true)"
                      @mouseleave="leaveEvent(item.questionnumber, index3, false)">
                      <div class="my-1 py-1" @click="selectAns(item.questionnumber,
                        i.value, AllAns[index].group), selectAns2(item.questionnumber,
                        i.value, AllAns[index].group)"
                        :class="{'bg-lightgreen':(!allwaysAns&&(finish2 && ShowCorrectAns(AllAns[item.questionnumber - 1].ans,i.value)))||(allwaysAns===true && (conselectedShowStatus[item.questionnumber - 1]&&(AllAns[item.questionnumber - 1].ans.indexOf(i.value)!== -1)||selectedStatus[item.questionnumber - 1]&&AllAns[item.questionnumber - 1].ans.indexOf(i.value)!== -1&&AllAns[item.questionnumber - 1].ans.indexOf(conselectedAns[item.questionnumber - 1])!== -1||AllAns[item.questionnumber - 1].ans.indexOf(conselectedAns[item.questionnumber - 1])=== -1&&selectedStatus[item.questionnumber-1]&&AllAns[item.questionnumber - 1].ans.indexOf(i.value)!==-1))}">
                        <!-- {{item.selectq}} - {{i.value}} -->
                        <!-- {{ `（${i.value}）${i.name}` }} -->
                        <div class="d-flex align-items-start position-relative">
                          <font-awesome-icon
                            v-if="(!allwaysAns&&(finish2 && !ShowCorrectAns(AllAns[item.questionnumber - 1].ans,i.value)&&conselectedAns[item.questionnumber - 1] === i.value))||((allwaysAns&&conselectedAns[item.questionnumber - 1] === i.value))&&(AllAns[item.questionnumber - 1].ans.indexOf(conselectedAns[item.questionnumber - 1])=== -1)"
                            class="text-secondary position-absolute" :icon="['fas', 'times']"
                            style="font-size:1.5rem;right:8px;bottom: 0;opacity:0.4" />
                          <div class="pr-1">({{i.value}})</div>
                          <div class="text-justify" v-html="`${i.name}`">

                          </div>
                        </div>
                        <small class="notes" v-if="getshowinfoquestion(item)"
                          v-html="i.notes"></small>
                      </div>
                    </div>
                  </div>
                </div>
              </b-card-text>
            </b-card-body>
          </div>
        </div>
      </div>
      <div class="col-xl-9 col-lg-9 offset-lg-3 col-12 order-lg-4 order-4">

        <div class="row no-gutters">

          <!-- 功能工具-->
          <div class="col-12 d-flex flex-wrap align-items-center py-0 px-3">
            <!-- 答對機率 -->
            <!-- <div class="mx-1 d-flex align-items-center">
                <span>答對率：</span>
                <div v-for="(item, jindex) in 5" :key="jindex">
                  <font-awesome-icon :icon="['fas', 'star']" />
                </div>
              </div> -->
            <!-- 逐題顯示上下題 -->

            <div
              class="d-inline-flex px-3 justify-content-end justify-content-md-end justify-content-lg-start justify-content-sm-end">
              <div v-if="single">
                <button type="button" class="btn btn-outline-dark"
                  @click="lessQ(item.questionnumber)" :disabled="qkey === 1">| 上一題
                  |</button>
              </div>
              <div v-if="single">
                <button type="button" class="btn btn-link"
                  @click="addGroupQ(index, item.questionnumber)"
                  :disabled="qkey==questions.length">| 下一題 |</button>
              </div>
            </div>
            <div class="ml-auto pl-3 px-md-5 ml-lg-auto mt-2">
              <template v-if="allwaysAns || finish2 && qa_method==='VIP'">
                <button v-b-tooltip.hover.bottom title="看答案" v-if="allwaysAns"
                  class="mybtn bg-white btn btn-outline-secondary mx-1"
                  @click="showAns(item.questionnumber)"
                  :class="{'active':conselectedShowStatus[item.questionnumber - 1]}">
                  <font-awesome-icon :icon="['fas', 'eye']" />
                </button>
                <button v-b-tooltip.hover.bottom title="看解析"
                  v-if="$route.params.examId.substr(2, 1) === '2'"
                  class="mybtn bg-white btn btn-outline-secondary mx-1"
                  :class="{active:showDetial||conselectedShowDetial[item.questionnumber - 1]}"
                  @click="showDetial_status?showDetial_status = false : showDetial_status = true,sohwDetial_method(item.questionnumber - 1, true)">
                  <font-awesome-icon :icon="['fas', 'question']" />
                </button>
              </template>
              <button v-b-tooltip.hover.bottom title="錯誤回報" v-if="qa_method==='VIP'"
                v-b-modal.modal-center @click="errorSubmit(item)"
                class="mybtn bg-white btn btn-outline-secondary mx-1">
                <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
              </button>
              <button v-b-tooltip.hover.bottom title="修改題目"
                v-if="qa_method==='VIP'&&userinfo.Authority" v-b-modal.modal-center2
                @click="modifyQuestions(item)"
                class="mybtn bg-white btn btn-outline-secondary mx-1">
                <font-awesome-icon :icon="['fas', 'tools']" />
              </button>
            </div>
          </div>

          <template v-if="showDetial||conselectedShowDetial[item.questionnumber - 1]">
            <div class="col-12 d-flex align-items-center justify-content-center p-3">
              <div v-if="item.unit_code.status !== null"
                class="d-flex border bg-light rounded flex-fill p-3 align-items-start">
                <div>命題範圍:</div>
                <div class="ml-3 text-dark">
                  《<a href="https://www.magee.tw/product/goodsmore/707" target="_blank">絕對考上導遊＋領隊
                    有聲書</a>》
                  <div class="ml-3">
                    <span>{{(item.unit_code.type=='A')? "第 1 冊 - 實務一&觀光資源概要":
                              (item.unit_code.type=='B')? "第 2 冊 - 實務二":"第 3 冊 - 領隊別冊"}}<br></span>
                    <span>CH
                      {{item.unit_code.code.substr(1, 1)}}　{{item.unit_code.name}}</span>
                    <span class="ml-2"> § {{item.subject_code.name}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="false"
              class="col-12 d-flex flex-column align-items-start justify-content-start p-3">
              <div class="AnalyzeNav d-flex w-25 justify-content-between">
                <div class="d-flex flex-fill justify-content-center align-items-center"
                  @click="AnalyzeType = 'student', ChangeAnalyzeType(item.questionnumber, AnalyzeType)"
                  :class="{active:AnalyzeTypeList[item.questionnumber - 1] === 'student'}">
                  <span>考生解題</span>
                  <b-badge variant="primary" class="rounded-circle ml-2">
                    {{msgAnalyzeTemp[1]['student'].length}}</b-badge>
                </div>
                <div class="d-flex flex-fill justify-content-center align-items-center"
                  @click="AnalyzeType = 'admin', ChangeAnalyzeType(item.questionnumber, AnalyzeType)"
                  :class="{active:AnalyzeTypeList[item.questionnumber - 1] === 'admin'}">
                  <span>站長解題</span>
                  <b-badge variant="primary" class="rounded-circle ml-2">
                    {{msgAnalyzeTemp[1]['admin'].length}}</b-badge>
                </div>
              </div>
              <div class="d-flex flex-column w-100">
                <div
                  v-for="(i, keys) in msgAnalyzeTemp[1][AnalyzeTypeList[item.questionnumber - 1]]"
                  :key="keys" class="d-flex flex-column border mx-1 mt-2 p-2 bg-white">
                  <div class="d-flex flex-fill flex-column justify-content-center">
                    <div class="d-flex flex-fill justify-content-start">
                      <b-avatar :src="i.img"></b-avatar>
                      <div class="d-flex flex-column align-items-start ml-2">
                        <span v-if="i.isBest" class="bg-danger p-1 rounded text-white">最佳解析</span>
                        <div class="d-flex">
                          <span>{{i.name}}</span>
                          <span class="ml-2">{{i.level}}</span>
                        </div>
                      </div>
                      <div class="d-flex ml-auto align-items-end">
                        <small>{{i.date}}</small>
                        <small class="ml-3">{{keys + 1 }} 樓</small>
                      </div>
                    </div>
                    <hr />
                    <div class="d-flex justify-content-between">
                      <div class="ml-5">
                        {{i.text}}
                      </div>
                      <div class="d-flex">
                        <span class="mx-1">
                          <font-awesome-icon :icon="['fa', 'thumbs-up']" />
                          {{i.thumbs_up}}</span>
                        <span class="mx-1">
                          <font-awesome-icon :icon="['fa', 'thumbs-down']" />
                          {{i.thumbs_down}}</span>
                        <small class="mx-1"><a href="#" @click.prevent>檢舉</a></small>
                      </div>

                    </div>
                  </div>
                </div>
                <div v-if="AnalyzeType === 'student'"
                  class="d-flex flex-column border mx-1 mt-2 p-2 bg-white">
                  <div>
                    <b-textarea></b-textarea>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </b-row>
  </div>
</template>
<script>
  export default {
    props: {
      parent:Object
    },
    watch:{
        parent:{
            deep:true,
            handler(newval,oldval){
                // this.parent
                console.log(newval);
            }
        }
    }
   
  }

</script>
